exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0bbce67a] .content-wrapper{padding:0!important}", ""]);

// exports
